/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_No_Related_EventsInputs */

const en_manual_qc_no_related_events = /** @type {(inputs: Manual_Qc_No_Related_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This issue is not related to any events`)
};

const fr_manual_qc_no_related_events = /** @type {(inputs: Manual_Qc_No_Related_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet incident n'est lie a aucun evenement`)
};

const de_manual_qc_no_related_events = /** @type {(inputs: Manual_Qc_No_Related_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Problem steht in keinem Zusammenhang mit irgendwelchen Ereignissen.`)
};

const it_manual_qc_no_related_events = /** @type {(inputs: Manual_Qc_No_Related_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo problema non è correlato ad alcun evento`)
};

const ru_manual_qc_no_related_events = /** @type {(inputs: Manual_Qc_No_Related_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Данная проблема не связана ни с какими событиями.`)
};

const es_manual_qc_no_related_events = /** @type {(inputs: Manual_Qc_No_Related_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este problema no está relacionado con ningún evento.`)
};

const zh_cn2_manual_qc_no_related_events = /** @type {(inputs: Manual_Qc_No_Related_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个问题与任何事件无关。`)
};

const ja_manual_qc_no_related_events = /** @type {(inputs: Manual_Qc_No_Related_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この問題はいかなるイベントとも関係ありません`)
};

const hi_manual_qc_no_related_events = /** @type {(inputs: Manual_Qc_No_Related_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह मुद्दा किसी घटना से संबंधित नहीं है।`)
};

const pt_pt2_manual_qc_no_related_events = /** @type {(inputs: Manual_Qc_No_Related_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este problema não está relacionado a nenhum evento.`)
};

/**
* | output |
* | --- |
* | "This issue is not related to any events" |
*
* @param {Manual_Qc_No_Related_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_no_related_events = /** @type {((inputs?: Manual_Qc_No_Related_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_No_Related_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_no_related_events(inputs)
	if (locale === "de") return de_manual_qc_no_related_events(inputs)
	if (locale === "it") return it_manual_qc_no_related_events(inputs)
	if (locale === "ru") return ru_manual_qc_no_related_events(inputs)
	if (locale === "es") return es_manual_qc_no_related_events(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_no_related_events(inputs)
	if (locale === "ja") return ja_manual_qc_no_related_events(inputs)
	if (locale === "hi") return hi_manual_qc_no_related_events(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_no_related_events(inputs)
	return en_manual_qc_no_related_events(inputs)
});